/* eslint-disable indent, no-param-reassign,no-plusplus, no-unused-vars */
import axios from 'axios';
import uniqBy from 'lodash/uniqBy';
import Vue from 'vue';
import cacheAxios from '../../util/cacheAxios';

const companyListAxios = axios.create();
const cache = new Map();
cacheAxios(companyListAxios, cache);

companyListAxios.interceptors.response.use(response => response,
  (error) => {
    if (error && error.response && error.response.status === 401) {
      setTimeout(() => {
        window.location.href = '/sign/in?source=/aims';
      }, 500);
    }
  });

function companyIndicatorComparator(a, b) {
  if (!a || !b) {
    return 1;
  }
  if (a.longName > b.longyName) {
    return 1;
  } else if (a.longName < b.longyName) {
    return -1;
  }
  if (a.reportDate > b.reportDate) {
    return 1;
  } else if (a.reportDate < b.reportDate) {
    return -1;
  }
  return 0;
}

export default {
  state: {
    years: [],
    countries: [],
    yearFilter: '',
    countryFilter: '',
    sectorFilter: '',
    companyIndicators: [],
    companyIndicatorSelected: {},
  },
  mutations: {
    setCompanyListYears(state, years) {
      state.years = years;
    },
    setCompanyListCountries(state, countries) {
      state.countries = countries;
    },
    setCompanyListYearFilter(state, filter) {
      state.yearFilter = filter;
    },
    setCompanyListCountryFilter(state, filter) {
      state.countryFilter = filter;
    },
    setCompanyListSectorFilter(state, filter) {
      state.sectorFilter = filter;
    },
    setCompanyIndicators(state, indicators) {
      state.companyIndicators = indicators;
    },
    addCompanyIndicators(state, indicators) {
      const index = state.companyIndicators.findIndex(i => i.reportDate === indicators.reportDate &&
        i.longName === indicators.longName);
      if (index >= 0) {
        Vue.set(state.companyIndicators, index, indicators);
        // state.companyIndicators[index] = indicators;
      } else {
        state.companyIndicators.push(indicators);
      }
    },
    removeCompanyIndicators(state, indicator) {
      state.companyIndicators = state.companyIndicators.filter(i => i.reportDate !==
        indicator.reportDate || i.longName !== indicator.longName);
    },
    setCompanyIndicatorSelected(state, indicator) {
      state.companyIndicatorSelected = indicator;
    },
  },
  actions: {
    initCountries({
      commit,
    }) {
      companyListAxios.get('/aims/api/benchmark/countries')
        .then((res) => {
          commit('setCompanyListCountries', res.data);
        });
    },
    initYears({
      commit,
    }) {
      companyListAxios.get('/aims/api/benchmark/years')
        .then((res) => {
          commit('setCompanyListYears', res.data);
        });
    },
    retrieveUserCompanyIndicators({
      commit,
    }) {
      companyListAxios.get('/aims/api/benchmark/currentUserCompanyIndicators')
        .then((res) => {
          commit('setCompanyIndicators', res.data);
        });
    },
    getCompanyIndicators({
      state,
      commit,
    }) {
      const q = {
        year: state.yearFilter,
        country: state.countryFilter,
        sector: state.sectorFilter,
      };
      if (q.year === '') {
        q.year = 0;
      }
      if (q.sector === '') {
        q.sector = 0;
      }
      companyListAxios.post('/aims/api/benchmark/indicatorsByYearCountrySector', q)
        .then((res) => {
          commit('setCompanyIndicators', res.data);
        });
    },
    saveCompanyIndicators({
      state,
      commit,
    }, companyIndicators) {
      return companyListAxios.post('/aims/api/benchmark/saveIndicator', companyIndicators)
        .then((res) => {
          if (res.status === 200) {
            commit('addCompanyIndicators', companyIndicators);
          }
          return res;
        });
    },
    deleteCompanyIndicators({
      state,
      commit,
    }, companyIndicators) {
      return companyListAxios.delete(
          `/aims/api/benchmark/deleteIndicator/${companyIndicators.longName}/${companyIndicators.reportDate}`,
        )
        .then((res) => {
          if (res.status === 200) {
            commit('removeCompanyIndicators', companyIndicators);
          }
          return res;
        });
    },
  },
  getters: {

  },
};



// WEBPACK FOOTER //
// ./src/store/modules/companyListModule.js